import { parsePositiveInteger } from '@iconik-io/core/src/parse_positive_integer';

import { DEFAULT_PER_PAGE } from '../../redux/common_list/constants';

export function getQueryPerPage(searchParams: string, storageKey: string) {
  const parsedQuery = new URLSearchParams(searchParams);
  const queryPerPage = parsePositiveInteger(parsedQuery.get('per_page'));

  const localStoragePerPage = parsePositiveInteger(
    window.localStorage.getItem(storageKey),
  );

  return queryPerPage ?? localStoragePerPage ?? DEFAULT_PER_PAGE;
}
